import { call, put, takeLatest } from 'redux-saga/effects'
import {
  sendMessage,
  getAllMessages
} from './message.reducer'
import Api from '../services/ApiCaller'
import { showMessage } from '../utils'
import {translate} from '../i18n'

export function* getAllMessagesRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllMessages.success(res))
    } else {
      yield put(getAllMessages.failure(message))
    }
  } catch (e) {
    yield put(getAllMessages.failure(e.message))
  }
}
export function* sendMessageRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(`${translate('message.sendMessageSuccess')}`)
      yield put(sendMessage.success(res))
    } else {
      yield put(sendMessage.failure(message))
    }
  } catch (e) {
    yield put(sendMessage.failure(e.message))
  }
}

interface IidData {
  id: number
}

interface ImessageContent {
  id: number,
  content: { }
}
export default (api: any) => {

  const getAllMessagesApi = (data: IidData) => api.get(`/messages/${data.id}`, data)
  const sendMessageApi = (data: ImessageContent) => api.post(`/messages/${data.id}`, data.content)
  return [
    takeLatest(getAllMessages.TRIGGER, getAllMessagesRequest, getAllMessagesApi),
    takeLatest(sendMessage.TRIGGER, sendMessageRequest, sendMessageApi)
  ]

}
